module.exports = __webpack_public_path__ + "static/media/temperature.86a57a77.svg";